/* eslint-disable import/no-cycle */
import { get } from 'lodash'

import { ThunkResult } from '../index'
import { IFRAME_VERSIONS, VERSIONS } from './versionTypes'

import { getReq } from '../../utils/request'

export interface IVersion {
	name: string
	version: string
	env: string
	envConfig: string
	envSentry: string
}

// BE version
export interface IVersionPayload {
	originalData: IVersion | null
}

// iFrame version
export interface IIframeVersionPayload {
	originalData: string | undefined
}

export const getBeVersions = (): ThunkResult<Promise<any>> => async (dispatch) => {
	try {
		dispatch({ type: VERSIONS.VERSIONS_LOAD_START })
		const { data } = await getReq('/api/maintenance/version/')
		const originalData = get(data, 'version', {})

		const payload: IVersionPayload = {
			originalData
		}

		dispatch({ type: VERSIONS.VERSIONS_LOAD_DONE, payload })
		return payload
	} catch (e) {
		dispatch({ type: VERSIONS.VERSIONS_LOAD_FAIL })
		return e
	}
}

export const getIframeVersions = (): ThunkResult<Promise<any>> => async (dispatch) => {
	try {
		dispatch({ type: IFRAME_VERSIONS.IFRAME_VERSIONS_LOAD_START })

		const { data } = await getReq('/iframe/version')
		const parser = new DOMParser()
		const doc = parser.parseFromString(data, 'text/html')
		const version = doc.getElementById('version')?.innerHTML
		const originalData = version
		const payload: IIframeVersionPayload = {
			originalData
		}

		dispatch({ type: IFRAME_VERSIONS.IFRAME_VERSIONS_LOAD_DONE, payload })
		return payload
	} catch (e) {
		dispatch({ type: IFRAME_VERSIONS.IFRAME_VERSIONS_LOAD_FAIL })
		return e
	}
}
